/**
 * Compact header dropdowns (CSS in blocks/_header-menu.liquid). Horizon positions every submenu
 * against the header row, and the menu list clips overflow, so the submenu can't anchor to its own
 * <li>. This sets --arvana-submenu-x on each submenu so it opens centred under its menu item,
 * kept inside the row. Desktop only; the overflow ("More") menu is left alone.
 */

const DESKTOP = window.matchMedia('(min-width: 750px)');
const ITEM_SELECTOR = '.menu-list__list-item:not([slot="overflow"]):not([slot="more"])';

/** @param {Element} item */
function place(item) {
  const submenu = item.querySelector(':scope > .menu-list__submenu');
  if (!(submenu instanceof HTMLElement) || !DESKTOP.matches) return;

  const container = submenu.offsetParent;
  if (!(container instanceof HTMLElement)) return;

  const bounds = container.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();
  const width = submenu.offsetWidth;
  const centre = itemRect.left + itemRect.width / 2 - bounds.left;
  const edge = 16;
  const x = Math.min(Math.max(centre - width / 2, edge), Math.max(edge, bounds.width - width - edge));

  submenu.style.setProperty('--arvana-submenu-x', `${Math.round(x)}px`);
}

function placeAll() {
  document.querySelectorAll(`header-menu ${ITEM_SELECTOR}`).forEach(place);
}

/** @param {Event} event */
function onEnter(event) {
  if (!(event.target instanceof Element)) return;
  const item = event.target.closest(ITEM_SELECTOR);
  if (!item?.closest('header-menu')) return;
  place(item);
  requestAnimationFrame(() => place(item));
}

document.addEventListener('pointerover', onEnter, { passive: true });
document.addEventListener('focusin', onEnter);
window.addEventListener('resize', placeAll, { passive: true });
document.addEventListener('shopify:section:load', placeAll);
placeAll();
